import { LassoSelectionStates } from "types/lasso";

import { getBoxPlotFilteredItems } from "./utils";

export function getBoxPlotList({
  params,
  series,
  chartInstance,
  isJitterOn
}: Partial<LassoSelectionStates>) {
  const list = getBoxPlotFilteredItems(params, series, chartInstance, isJitterOn);
  return list;
}
